import { ChangeDetectionStrategy, Component } from '@angular/core';

// Body of a toast shown through ToastService: optional bold title, then the message as text or,
// when the caller asked for enableHtml, as (sanitized) HTML. Clicking the body dismisses the toast
// unless the caller opted out with tapToDismiss: false.
@Component({
    selector: 'app-toast-content',
    template: `
        <div class="pcs-toast-body" [class.pcs-toast-clickable]="!!dismiss" (click)="onClick()">
            @if (title) {
                <div class="pcs-toast-title">{{ title }}</div>
            }
            @if (html) {
                <div class="pcs-toast-message" [innerHTML]="message"></div>
            } @else {
                <div class="pcs-toast-message">{{ message }}</div>
            }
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToastContentComponent {
    title: string | null = null;
    message = '';
    html = false;
    dismiss: (() => void) | null = null;

    onClick(): void {
        if (this.dismiss) {
            this.dismiss();
        }
    }
}
